import React from 'react'
import { get, map } from 'lodash'
import { Field, ErrorMessage } from 'formik'

export default function SuburbsCheckboxList({ towns, townDataOption, selectedRole, setFieldValue, getTownsOptionBySuburbs }) {
  const handleSelectionSuburbs = async (townId, seletctedtowns, role, setFieldValue) => {
    let towns = seletctedtowns;
    if (towns.includes(parseInt(townId))) {
      towns = towns.filter(town => town !== parseInt(townId))
    } else {
      towns.push(parseInt(townId))
    }
    if (role === 'agent' || role === 'business development') {
      const townsOptions = await getTownsOptionBySuburbs({ suburb_arr: towns })
      if (get(townsOptions, 'value.data', false)) {
        const searchTownOption = map(get(townsOptions, 'value.data', []), town => {
          return { label: town.name, value: town.id }
        })
        setFieldValue('searchTownOption', searchTownOption)
      }
    }
    setFieldValue('towns', towns)
  }
  return (
    <div className="form-group">
      <label className="label__text__sm">Suburbs<span className="text-danger">*</span></label>
      <ul className="checkbox__list checkbox-list-grid">
        {map(townDataOption, (town, index) => (
          <li key={index}>
            <label className="custom__checkbox">
              <Field
                type="checkbox"
                id={`town_${town.value}`}
                className="custom__checkbox__input"
                checked={towns.includes(town.value)}
                onClick={() => handleSelectionSuburbs(town.value, towns, selectedRole, setFieldValue)}
                required
              />
              {town.label}
              <span className="custom__checkmark"></span>
            </label>
          </li>
        ))}
      </ul>
      <ErrorMessage className="invalid-feedback" name="towns" component="div" />
    </div>
  )
}
